import {Component, viewChild, signal, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ModalComponent} from '../../../../shared/components/modal/modal.component';
import {ToastrService} from 'ngx-toastr';
import {UserGroup} from '../../../../classes/models/user/UserGroup';
import {UserGroupsService} from '../../../../services/http/user/user-groups.service';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * This component handles creating a new user group.
 */
@Component({
  selector: 'app-user-groups-form',
  templateUrl: './user-groups-form.component.html',
  styleUrls: ['./user-groups-form.component.less'],
  imports: [SHARED_IMPORTS]
})
export class UserGroupsFormComponent {

  private readonly userGroupsService = inject(UserGroupsService);
  private readonly toastr = inject(ToastrService);
  private readonly destroyRef = inject(DestroyRef);

  /** A modal component of user group form. */
  readonly modalComponent = viewChild.required<ModalComponent>('modalComponent');

  /** A form value of user group email. */
  readonly groupEmail = signal('');
  /** A form value of user group description. */
  readonly groupDescription = signal('');
  /** `True` if request to backend is loading. */
  readonly loading = signal(false);

  static open(modalService: NgbModal): NgbModalRef {
    return modalService.open(UserGroupsFormComponent);
  }

  /**
   * Sends request to backend to create a new user group.
   */
  onSubmit(): void {
    this.loading.set(true);

    const userGroup = new UserGroup(this.groupEmail(), this.groupDescription(), []);
    this.userGroupsService.addUserGroup(userGroup)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: () => {
                this.modalComponent().activeModal.close();
                this.loading.set(false);
                this.toastr.success('User group has been successfully created');
              },
              error: (error) => {
                this.loading.set(false);
                this.toastr.error(error.error.message);
              }
            });
  }
}